/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectSpread2 as _objectSpread2, typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.js';
import generateGQLSchema from '../utils/generateGQLSchema.js';
import { indexInterpolate } from '../utils/indexInterpolate.js';
import request from '../utils/request.js';
import getQueryParams from '../utils/getQueryParams.js';

var modify = function modify(_ref) {
  var params = _ref.params,
    options = _ref.options,
    method = _ref.method,
    mockResponse = _ref.mock,
    uri = _ref.uri,
    headers = _ref.headers,
    enableImsAccountHeader = _ref.enableImsAccountHeader,
    enableBssAccountHeader = _ref.enableBssAccountHeader,
    graphql = _ref.graphql,
    _ref$dataHelper = _ref.dataHelper,
    dataHelper = _ref$dataHelper === void 0 ? function (data) {
      return data;
    } : _ref$dataHelper;
  return new Promise(function (resolve, reject) {
    var _options$mock = options.mock,
      mock = _options$mock === void 0 ? false : _options$mock,
      queryParams = options.queryParams,
      customSchema = options.customSchema,
      optionsHeaders = options.headers,
      _options$throwObject = options.throwObject,
      throwObject = _options$throwObject === void 0 ? false : _options$throwObject,
      _options$rejectOnGrap = options.rejectOnGraphqlErrors,
      rejectOnGraphqlErrors = _options$rejectOnGrap === void 0 ? false : _options$rejectOnGrap;
    var finalUri = uri;
    if (uri.match(/\{\{\d+}}/)) {
      finalUri = indexInterpolate(uri, options.templateKeys);
    }
    if (mock) {
      // After 1 second return mock data
      setTimeout(function () {
        var data = {
          loading: false,
          data: mockResponse(params),
          error: null,
          status: 200
        };
        resolve(data);
      }, 1000);
    } else {
      var uriWithQueryParams = "".concat(finalUri).concat(getQueryParams(queryParams, true));

      // Make the request
      request(uriWithQueryParams, {
        method: method,
        headers: _objectSpread2(_objectSpread2({}, headers), optionsHeaders),
        enableImsAccountHeader: enableImsAccountHeader,
        enableBssAccountHeader: enableBssAccountHeader,
        credentials: 'include',
        body: JSON.stringify(graphql // If a graphql is provided then generate a graphql request body
        ? {
          query: generateGQLSchema(graphql, customSchema, true),
          variables: params
        } : params)
      }).then(function (response) {
        // Get status from the response to be returned with the data/error
        var status = response.status;
        var loadResponse = response.text();
        loadResponse.then(function (rawbody) {
          var body = rawbody;
          if (rawbody.length) {
            try {
              body = JSON.parse(rawbody);
              // eslint-disable-next-line no-empty
            } catch (error) {}
          }
          if (status >= 400) {
            if (throwObject) {
              var rejectBody = {
                loading: false,
                data: null,
                error: body || {
                  status: status
                },
                status: status
              };
              reject(rejectBody);
            } else {
              var _rejectBody = body || {
                status: status
              };
              // Add the status code for error reporting
              if (_typeof(_rejectBody) === 'object') {
                _rejectBody.statusCode = _rejectBody.statusCode || status;
                _rejectBody.status = _rejectBody.status || status;
              }
              reject(_rejectBody);
            }
          } else if (graphql) {
            var _body$errors;
            // If the call is a grahpql call render data from the graphql response
            var data = {
              loading: false,
              data: dataHelper(body.data && body.data[graphql.name]) || null,
              error: body.errors && body.errors[0] || null,
              status: body.errors && body.errors[0].statusCode || status,
              errors: body.errors || null
            };
            if (rejectOnGraphqlErrors && (_body$errors = body.errors) !== null && _body$errors !== void 0 && _body$errors.length || data.status < 200 || data.status >= 300) {
              reject(data);
            } else {
              resolve(data);
            }
          } else {
            // non-graphql success path
            var _data = {
              loading: false,
              data: dataHelper(body),
              error: null,
              status: status
            };
            resolve(_data);
          }
        })["catch"](function (error) {
          reject(error);
        });
      })["catch"](function (error) {
        reject(error);
      });
    }
  });
};
var modify$1 = modify;

export { modify$1 as default };
